import React from 'react';
import { ingredients } from '../data/content';
import './Ingredients.css';

export default function Ingredients() {
  return (
    <section className="ingredients-section" id="ingredients">
      <span className="section-eyebrow">Power of 4</span>
      <h2 className="section-title">Sacred Herbs,<br />Proven by Tradition</h2>
      <p className="section-sub">
        Each ingredient is carefully selected from nature's pharmacy, used for generations
        in Ayurvedic wellness to support metabolic balance.
      </p>

      <div className="ingredients-grid">
        {ingredients.map((ing) => (
          <div className="ing-card" key={ing.name}>
            <span className="ing-emoji">{ing.emoji}</span>
            <div className="ing-name">{ing.name}</div>
            <div className="ing-aka">{ing.aka}</div>
            <p className="ing-desc">{ing.desc}</p>
            <span className="ing-benefit">{ing.benefit}</span>
          </div>
        ))}
      </div>
    </section>
  );
}
